module.exports = __webpack_public_path__ + "static/media/menu_home.3f436e42.svg";